export function getCompositeStyles(props) {
    const styles = {
        subComponentStyles: {
            commandBar: {
                root: {
                    borderRadius: 0,
                },
            },
            pivot: {},
            pivotSearchBox: {},
            emptyState: {},
            customPivotSearchCloseStyles: {},
        },
    };
    return styles;
}
//# sourceMappingURL=CompositeList.styles.js.map